import {
  ComparisonSpecType,
  isHistoricalComparisonSpec,
  isMarkBasedComparison as isMarkBasedComparisonSpec,
  isStaticComparison,
} from './models';
import { DateWindow, isLatestDataWindow } from './features/window';

export const isValueWithinRange = (value: number | null, max: number, min: number): boolean => {
  return value !== null && value >= min && value <= max;
};

export const isValidConstantComparison = (value: number | null): boolean => {
  return isValueWithinRange(value, Number.MAX_SAFE_INTEGER, Number.MIN_SAFE_INTEGER);
};

export const MINIMUM_RELATIVE_UNITS = 1;
export const MAXIMUM_RELATIVE_UNITS = 10000;

export function isValidRelativeDateRangeInput(value: number | null): boolean {
  return isValueWithinRange(value, MAXIMUM_RELATIVE_UNITS, MINIMUM_RELATIVE_UNITS);
}

export const MINIMUM_COMPARISON_VALUE = 1;
export const MAXIMUM_COMPARISON_VALUE = 10000;

export function isValidHistoricalComparisonInput(value: number | null): boolean {
  return isValueWithinRange(value, MAXIMUM_COMPARISON_VALUE, MINIMUM_COMPARISON_VALUE);
}

export function isValidConfiguration(
  comparison: ComparisonSpecType | null,
  window: DateWindow | null,
  hasDateDimension: boolean
): boolean {
  if (comparison === null) {
    return false;
  }

  const isConstantComparison = isStaticComparison(comparison);
  const isHistoricalComparison = isHistoricalComparisonSpec(comparison);
  const isMarkBasedComparison = isMarkBasedComparisonSpec(comparison);

  if (isConstantComparison && !isValidConstantComparison(comparison.value)) {
    return false;
  }

  if (isHistoricalComparison || isMarkBasedComparison) {
    const units = (isHistoricalComparison ? comparison.numberOfPeriods : comparison.numberOfMarks) ?? null;
    if (!isValidHistoricalComparisonInput(units)) {
      return false;
    }
  }

  if (hasDateDimension && window === null) {
    return false;
  }

  if (window !== null && isLatestDataWindow(window) && !isValidRelativeDateRangeInput(window.duration.numberOfUnits)) {
    return false;
  }

  return true;
}
